// Letter-avatar fallback for model providers without a logo URL.

const PALETTE = [
  '#f97316', '#0ea5e9', '#8b5cf6', '#10b981',
  '#ef4444', '#eab308', '#ec4899', '#14b8a6',
];

export function providerInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function providerColor(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return PALETTE[Math.abs(hash) % PALETTE.length];
}
